<template>
  <div class="row">
    <div
      class="col-12"
      v-if="
        info.requestSignedHistorical ||
        info.requestSignedAgreement ||
        info.requestSigned
      "
    >
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>SOLICITUD</h5>
      </legend>
      <table class="table table-sm table-striped" v-if="info.requestSigned">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="info.requestSignedHistorical">
            <td class="align-middle">Historico - Solicitud de Acreditación</td>
            <td class="align-middle text-center">
              {{
                info.requestSignedHistorical.user
                  ? `${info.requestSignedHistorical.user.first_name} ${info.requestSignedHistorical.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.requestSignedHistorical.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.requestSignedHistorical)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
          <!-- <tr v-if="info.requestSignedAgreement">
            <td class="align-middle">
              Historico - Solicitud de Acreditación (Convenio)
            </td>
            <td class="align-middle text-center">
              {{
                info.requestSignedAgreement.user
                  ? `${info.requestSignedAgreement.user.first_name} ${info.requestSignedAgreement.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.requestSignedAgreement.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.requestSignedAgreement)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr> -->
          <tr v-if="info.requestSigned">
            <td class="align-middle">Solicitud de Acreditación</td>
            <td class="align-middle text-center">
              {{
                info.requestSigned.user
                  ? `${info.requestSigned.user.first_name} ${info.requestSigned.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.requestSigned.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.requestSigned)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
          <tr
            v-if="
              info.accApp.accreditation_type_id == 1 ||
              info.accApp.accreditation_type_id == 2 ||
              info.accApp.accreditation_type_id == 10 ||
              info.accApp.accreditation_type_id == 11
            "
          >
            <td class="align-middle">Anexos de solicitud</td>
            <td class="align-middle text-center">
              {{
                info.requestSigned.user
                  ? `${info.requestSigned.user.first_name} ${info.requestSigned.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.requestSigned.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTabDownload()"
              >
                {{ $t("Descargar comprimido") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="col-12"
      v-if="info.accApp && (info.accApp.accreditation_type_id == 9 || info.accApp.accreditation_type_id == 11)"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="align-middle">Renovación-Compromiso de cumplimiento</td>
            <td class="align-middle text-center">
              {{
                compliance.user
                    ? `${compliance.user.first_name} ${compliance.user.last_name}`
                    : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ compliance.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTabRenovation(info.accApp.id, info.accApp.status)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="col-12" v-if="info.deposits && info.deposits.length > 0">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>DEPOSITOS</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.deposits" :key="i">
            <td class="align-middle">
              {{ v.is_agreement == 0 ? "Deposito" : "Convenio" }} {{ i + 1 }}
            </td>
            <td class="align-middle text-center">
              <span v-if="v.file">
                {{ `${v.file.user.first_name} ${v.file.user.last_name}` }}
              </span>
            </td>
            <td class="align-middle text-center">
              <span v-if="v.file">
                {{ v.file.created_at | dateFormat }}
              </span>
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.file)"
                v-if="v.file"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12" v-if="info.deposits && info.deposits.length > 0">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>FACTURAS EMITIDAS</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody v-for="(v, i) in info.deposits" :key="i">
          <tr v-for="(u, j) in v.invoices" :key="j">
            <!-- <div style="width:100%" > -->
              <td class="align-middle">{{u.filename}}</td>
              <td class="align-middle text-center">
                <span v-if="u.annexed">
                  {{ `${u.annexed.user.first_name} ${u.annexed.user.last_name}` }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span v-if="u.file">
                  {{ u.file.created_at | dateFormat }}
                </span>
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(u.annexed)"
                  v-if="u.annexed"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            <!-- </div> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="col-12"
      v-if="
        (info.receiptReturnReportNoSigned &&
          info.receiptReturnReportNoSigned.length) > 0 ||
        info.receiptReturnReport
      "
    >
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>REGISTRO DE INGRESO DE SOLICITUD DE ACREDITACIÓN Y ACUSE RECIBO</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.receiptReturnReportNoSigned" :key="i">
            <td class="align-middle">
              Registro de Ingreso de solicitud de acreditación y acuse recibo -
              {{ i + 1 }}
            </td>
            <td class="align-middle text-center">
              {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{ v.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
          <tr v-if="info.receiptReturnReport">
            <td class="align-middle">
              Registro de Ingreso de solicitud de acreditación y acuse recibo
            </td>
            <td class="align-middle text-center">
              {{
                info.receiptReturnReport.user
                  ? `${info.receiptReturnReport.user.first_name} ${info.receiptReturnReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.receiptReturnReport.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.receiptReturnReport)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="col-12"
      v-if="
        info.directorTechnicalReport ||
        info.scope607 ||
        info.evidenceMemberParticipation ||
        info.technicalFileAnalysisReport ||
        info.maintenancePlan ||
        info.areaDirectorReport ||
        info.generalTechnicalCoordinationReport ||
        info.legalReport ||
        info.draftResolution ||
        info.legalReportDirector ||
        info.legalResolutionDirector
      "
    >
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>ETAPA DE DECISIÓN</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="info.evidenceMemberParticipation">
            <td class="align-middle">
              Evidencia de participación de los miembros de la comisión
            </td>
            <td class="align-middle text-center">
              {{
                info.evidenceMemberParticipation.user
                  ? `${info.evidenceMemberParticipation.user.first_name} ${info.evidenceMemberParticipation.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.evidenceMemberParticipation.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.evidenceMemberParticipation)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.technicalFileAnalysisReport">
            <td class="align-middle">
              Informe Técnico de Análisis de Expediente y de Toma de Decisión
            </td>
            <td class="align-middle text-center">
              {{
                info.technicalFileAnalysisReport.user
                  ? `${info.technicalFileAnalysisReport.user.first_name} ${info.technicalFileAnalysisReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.technicalFileAnalysisReport.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.technicalFileAnalysisReport)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.maintenancePlan">
            <td class="align-middle">Anexo del Plan de Mantenimiento</td>
            <td class="align-middle text-center">
              {{
                info.maintenancePlan.user
                  ? `${info.maintenancePlan.user.first_name} ${info.maintenancePlan.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.maintenancePlan.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.maintenancePlan)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.directorTechnicalReport">
            <td class="align-middle">
              Borrador del Informe Técnico del Director de Área
            </td>
            <td class="align-middle text-center">
              {{
                info.directorTechnicalReport.user
                  ? `${info.directorTechnicalReport.user.first_name} ${info.directorTechnicalReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.directorTechnicalReport.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.directorTechnicalReport)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.scope607">
            <td class="align-middle">Alcance de acreditación</td>
            <td class="align-middle text-center">
              {{
                info.scope607.user
                  ? `${info.scope607.user.first_name} ${info.scope607.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.scope607.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.scope607)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.areaDirectorReport">
            <td class="align-middle">Informe Director de Área</td>
            <td class="align-middle text-center">
              {{
                info.areaDirectorReport.user
                  ? `${info.areaDirectorReport.user.first_name} ${info.areaDirectorReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.areaDirectorReport.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.areaDirectorReport)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.generalTechnicalCoordinationReport">
            <td class="align-middle">Informe Coordinación General Técnica</td>
            <td class="align-middle text-center">
              {{
                info.generalTechnicalCoordinationReport.user
                  ? `${info.generalTechnicalCoordinationReport.user.first_name} ${info.generalTechnicalCoordinationReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{
                info.generalTechnicalCoordinationReport.created_at | dateFormat
              }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(info.generalTechnicalCoordinationReport)
                "
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.legalReport">
            <td class="align-middle">Borrador Informe Jurídico</td>
            <td class="align-middle text-center">
              {{
                info.legalReport.user
                  ? `${info.legalReport.user.first_name} ${info.legalReport.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.legalReport.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.legalReport)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.draftResolution">
            <td class="align-middle">Borrador Resolución</td>
            <td class="align-middle text-center">
              {{
                info.draftResolution.user
                  ? `${info.draftResolution.user.first_name} ${info.draftResolution.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.draftResolution.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.draftResolution)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.legalReportDirector">
            <td class="align-middle">Informe Jurídico</td>
            <td class="align-middle text-center">
              {{
                info.legalReportDirector.user
                  ? `${info.legalReportDirector.user.first_name} ${info.legalReportDirector.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.legalReportDirector.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.legalReportDirector)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="info.legalResolutionDirector">
            <td class="align-middle">Resolución</td>
            <td class="align-middle text-center">
              {{
                info.legalResolutionDirector.user
                  ? `${info.legalResolutionDirector.user.first_name} ${info.legalResolutionDirector.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.legalResolutionDirector.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.legalResolutionDirector)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <legend
      class="col-12 col-form-label text-primary pt-0 my-3"
      v-if="info.additional_605 && info.additional_605.length > 0"
    >
      <h5 v-if="info.accApp.accreditation_type_id != 100">
        <b>(Reunión de la Comisión de Acreditación):</b> Documentos adicionales
        para subsanar o complementar el proceso
      </h5>
      <h5 v-if="info.accApp.accreditation_type_id == 100">
        Anexos carga de alcances acreditados
      </h5>
    </legend>
    <div
      class="col-12"
      v-if="info.additional_605 && info.additional_605.length > 0"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">OBSERVACIÓN</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.additional_605" :key="i">
            <td class="align-middle">
              {{ v.annexed.user ? `${v.filename}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{
                v.annexed.user
                  ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ v.annexed.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.annexed)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <legend
      class="col-12 col-form-label text-primary pt-0 my-3"
      v-if="info.additional_600 && info.additional_600.length > 0"
    >
      <h5 v-if="info.accApp.accreditation_type_id != 100">
        <b>(Toma de decisión - gestor técnico):</b> Documentos adicionales
        para subsanar o complementar el proceso
      </h5>
      <h5 v-if="info.accApp.accreditation_type_id == 100">
        Anexos carga de alcances acreditados
      </h5>
    </legend>
    <div
      class="col-12"
      v-if="info.additional_600 && info.additional_600.length > 0"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">OBSERVACIÓN</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.additional_600" :key="i">
            <td class="align-middle">
              {{ v.annexed.user ? `${v.filename}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{
                v.annexed.user
                  ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ v.annexed.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.annexed)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <legend
      class="col-12 col-form-label text-primary pt-0 my-3"
      v-if="info.additional_608 && info.additional_608.length > 0"
    >
      <h5>
        <b>(Informe Director de Área):</b> Documentos adicionales para subsanar
        o complementar el proceso
      </h5>
    </legend>
    <div
      class="col-12"
      v-if="info.additional_608 && info.additional_608.length > 0"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">OBSERVACIÓN</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.additional_608" :key="i">
            <td class="align-middle">
              {{ v.annexed.user ? `${v.filename}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{
                v.annexed.user
                  ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ v.annexed.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.annexed)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <legend
      class="col-12 col-form-label text-primary pt-0 my-3"
      v-if="info.additional_609 && info.additional_609.length > 0"
    >
      <h5>
        <b>(Informe Coordinación General Técnica):</b> Documentos adicionales
        para subsanar o complementar el proceso
      </h5>
    </legend>
    <div
      class="col-12"
      v-if="info.additional_609 && info.additional_609.length > 0"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">OBSERVACIÓN</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.additional_609" :key="i">
            <td class="align-middle">
              {{ v.annexed.user ? `${v.filename}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{
                v.annexed.user
                  ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ v.annexed.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.annexed)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <legend
      class="col-12 col-form-label text-primary pt-0 my-3"
      v-if="info.additional_610 && info.additional_610.length > 0"
    >
      <h5>
        <b>(Elaboración de Informe Jurídico para la Acreditación):</b>
        Documentos adicionales para subsanar o complementar el proceso
      </h5>
    </legend>
    <div
      class="col-12"
      v-if="info.additional_610 && info.additional_610.length > 0"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">OBSERVACIÓN</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.additional_610" :key="i">
            <td class="align-middle">
              {{ v.annexed.user ? `${v.filename}` : "" }}
            </td>
            <td class="align-middle text-center">
              {{
                v.annexed.user
                  ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ v.annexed.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(v.annexed)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12" v-if="info.subscribedAccreditationResolution">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>RESOLUCIÓN SUSCRITA</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="info.subscribedAccreditationResolution">
            <td class="align-middle">Resolución suscrita</td>
            <td class="align-middle text-center">
              {{
                info.subscribedAccreditationResolution.user
                  ? `${info.subscribedAccreditationResolution.user.first_name} ${info.subscribedAccreditationResolution.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{
                info.subscribedAccreditationResolution.created_at | dateFormat
              }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.subscribedAccreditationResolution)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12" v-if="info.documents && info.documents.length > 0">
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>INFORMES</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in info.documents" :key="i">
            <td class="align-middle">
              {{ v.matter }}
            </td>
            <td class="align-middle text-center">
              <span>
                {{ v.from_user.full_name }}
              </span>
            </td>
            <td class="align-middle text-center">
              <span>
                {{ v.created_at | dateFormat }}
              </span>
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTabInfo(v.accreditation_id, v.status.code)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="col-12"
      v-if="info.certificateAccreditationSymbol || info.accreditationSymbol"
    >
      <legend class="col-12 col-form-label text-primary pt-0 my-3">
        <h5>COPIA CERTIFICADO DE ACREDITACIÓN Y SÍMBOLO DE ACREDITACIÓN</h5>
      </legend>
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="align-middle">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="align-middle text-center" style="width: 15%">
              FECHA
            </th>
            <th
              scope="col"
              class="align-middle text-center"
              style="width: 10%"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="info.certificateAccreditationSymbol">
            <td class="align-middle">Copia Certificado de Acreditación</td>
            <td class="align-middle text-center">
              {{
                info.certificateAccreditationSymbol.user
                  ? `${info.certificateAccreditationSymbol.user.first_name} ${info.certificateAccreditationSymbol.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.certificateAccreditationSymbol.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.certificateAccreditationSymbol)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
          <tr v-if="info.accreditationSymbol">
            <td class="align-middle">Símbolo de Acreditación</td>
            <td class="align-middle text-center">
              {{
                info.accreditationSymbol.user
                  ? `${info.accreditationSymbol.user.first_name} ${info.accreditationSymbol.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ info.accreditationSymbol.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(info.accreditationSymbol)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  data() {
    return {
      info: {
        deposits: [],
        receiptReturnReportNoSigned: [],
      },
      compliance: {},
      date_compliance: "",
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.getData();
    });
    this.getData();
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
  methods: {
    getData() {
      this.preloader = true;
      let url = `/audit/accreditation/${this.$store.state.common.accAppId}/show`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            // console.log(response.data);
            this.info = response.data;
            // this.$store.state.common.accApp = response.data.accApp;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });

      let urlren = `/audit/accreditation/getAccApp/${this.$store.state.common.accAppId}`;
      axiosGet(urlren)
        .then((response) => {
          this.compliance = response.data;
          if(this.compliance.historical) {
            for(var i = 0 ; i <this.compliance.historical.length ; i++) {
              if(this.compliance.historical[i].status.code == '108') {
                this.date_compliance = this.compliance.historical[i].updated_at;
                break;
              }
          }
          }
          
          
        });
    },

    openTabInfo(accAppId, status) {
      if (status == "605") {
        let path = `/evaluator/decision/closureFindingsDecision/view/${accAppId}?tab=Borrador del Informe Técnico`;
        window.open(path, "_blank").focus();
      }
      if (status == "608") {
        let path = `/accreditationReview/decision/areaDirectorReport/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "609") {
        let path = `/accreditationtechnical/generalTechnicalCoordination/generalTechnicalCoordinationReport/view/${accAppId}?tab=Evaluación%20/%20Testificación`;
        window.open(path, "_blank").focus();
      }
      if (status == "610") {
        let path = `/accreditationExecutive/legalValidation/610/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "613") {
        let path = `/accreditationExecutive/directorLegalValidation/613/view/${accAppId}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
    },
    openTabRenovation(accAppId, status) {
      if (status != "8" && status != "60" && status != "2" && status != "10") {
        let path = `/accreditations/process/renovation/view/${accAppId}`;
        window.open(path, "_blank").focus();
      }
    },
    openTab(file) {
      var info = {};
      info['accAppId'] = Number(this.$store.state.common.accAppId);
      info['evalTestId'] = null;
      info['path'] = String(file.path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(file.path, "_blank");
      w.focus();
    },
    openTabDownload() {
      let w;
      w = window.open(
        `/annexes/download?accAppId=${this.$store.state.common.accAppId}`,
        "_blank"
      );
      w.focus();
    },
  },
};
</script>